import { DashboardConfig } from '../../../common/components/dashboards/types';
import { FinancialYearYearlyTimesliderGranularity } from '../../../common/components/timeslider/constants';
import { TimeSliderTypes } from '../../../common/components/timeslider/types';
import { Languages } from '../../../constants';
import {
  getEligibleForParentalLeave2Factbox,
  getEligibleForParentalLeave3Factbox,
  getEligibleForParentalLeaveFactbox,
  getFiscalYearTimeSelection,
  getIndividualsCount2Factbox,
  getIndividualsCountFactbox,
  getMonthlyOvertimeFactbox,
  getParentalLeaveTakenFactbox,
  getParentalLeaveTakenUtilizationFactbox,
} from './jt-chart-helpers';

export const JTDashboardChartConfig: DashboardConfig = {
  id: 'jt_custom_db_1',
  title: {
    [Languages.EN]: 'Platinum Kurumin',
    [Languages.JA]: 'プラチナくるみん',
  },
  enabled: true,
  superAdminOnly: true,
  pages: [
    {
      pageId: '1',
      dashboardId: 'jt_custom_db_1',
      pageNumber: 1,
      enabled: true,
      title: {
        [Languages.EN]: 'Platinum Kurumin',
        [Languages.JA]: 'プラチナくるみん',
      },
      pageOptions: {
        displayOptions: {
          enabled: false,
        },
        timeOptions: {
          timeSliderEnabled: true,
          timeSliderType: TimeSliderTypes.POINT,
          defaultGranularity: FinancialYearYearlyTimesliderGranularity,
        },
        filterTray: {
          enabled: false,
        },
        dataView: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
      },
      gridCols: 20,
      configType: 'componentConfigs',
      components: ({ storyboardDateUtils, domainPreferences }) => [
        // Row 1: 4 factboxes
        getEligibleForParentalLeaveFactbox(
          getFiscalYearTimeSelection(storyboardDateUtils, domainPreferences)
        ),
        getParentalLeaveTakenFactbox(
          getFiscalYearTimeSelection(storyboardDateUtils, domainPreferences)
        ),
        getParentalLeaveTakenUtilizationFactbox(
          getFiscalYearTimeSelection(storyboardDateUtils, domainPreferences)
        ),
        getIndividualsCountFactbox(storyboardDateUtils, domainPreferences),
        // Row 2: 4 factboxes
        getMonthlyOvertimeFactbox(storyboardDateUtils, domainPreferences),
        getIndividualsCount2Factbox(
          getFiscalYearTimeSelection(storyboardDateUtils, domainPreferences)
        ),
        getEligibleForParentalLeave2Factbox(
          getFiscalYearTimeSelection(storyboardDateUtils, domainPreferences, -2)
        ),
        getEligibleForParentalLeave3Factbox(
          getFiscalYearTimeSelection(storyboardDateUtils, domainPreferences, -1)
        ),
      ],
    },
  ],
};
